import { UpdateSubjectPlanPayload } from "@twinkltech/curriculum-architect-domain-hooks";

import { TableData } from "@/states/unitTableReducer/unitTableReducer";

export const mapTableDataToUpdatePlanPayload = (
  tableData: Pick<TableData, "columns" | "rows" | "cells">
): UpdateSubjectPlanPayload["value"] => {
  return {
    rows: tableData.rows.map((row) => ({
      rowId: row.id,
      slug: row.slug,
      displayLabel: row.title,
      order: row.order,
      attributes: {
        keyStages: row.keyStages,
      },
    })),
    columns: tableData.columns.map((column) => ({
      columnId: column.id,
      slug: column.slug,
      displayLabel: column.title,
      order: column.order,
    })),
    cells: tableData.cells.map((cell) =>
      cell.isCustom
        ? {
            cellId: cell.id,
            columnId: cell.column,
            rowId: cell.row,
            span: cell.span,
            isCustom: true as const,
            title: cell.title,
            description: cell.description,
          }
        : {
            cellId: cell.id,
            resourceId: cell.resourceId,
            columnId: cell.column,
            rowId: cell.row,
            span: cell.span,
            adaptationNote: cell.adaptationNote || undefined,
          }
    ),
  };
};
